import PdfContent from './pdf-content';

import { createContainer } from '@dbk-legacy/muster/react';

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    languages: {
      destLanguage: true,
      destLanguageCode: true,
    },
  },
})(PdfContent);
